/**
 * Shift Schedule Page - Microsoft 365 Style
 * View and manage shift schedules
 */

import React from 'react';
import { makeStyles, Text } from '@fluentui/react-components';
import { ContentCard } from '../../../components/layout';

const useStyles = makeStyles({
  pageHeader: { marginBottom: '24px' },
  pageTitle: { fontSize: '24px', fontWeight: '600', color: '#323130' },
});

export const ShiftScheduleFluentUI: React.FC = () => {
  const styles = useStyles();

  return (
    <div>
      <div className={styles.pageHeader}>
        <Text className={styles.pageTitle}>Shift Schedule</Text>
      </div>

      <ContentCard>
        <Text>Shift scheduling interface - Feature in development</Text>
      </ContentCard>
    </div>
  );
};

export default ShiftScheduleFluentUI;
